module.exports = __webpack_public_path__ + "Popularity-IuMbhu5.svg";